const handleDeleteEmployeeMyComp = {
  confirm: 'Deseja realmente deletar esse colaborador?',
  title: 'DELETAR COLABORADOR'
};

export default handleDeleteEmployeeMyComp;
